export const STATUS = {
    PENDING: 'PENDING',
    APPROVE: 'APPROVE',
    DENY: 'DENY'
}

export const ANIMAL_TYPE = [
    {
        id: 1,
        name: "Chó"
    },
    {
        id: 2,
        name: "Mèo"
    },
    {
        id: 3,
        name: "Khác"
    }
]